import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  connect() {
    reactor(this)
    this.shown = this.rowIds
  }

  // Idiomorph detaches and re-inserts kept rows when one is prepended, which restarts their CSS animation.
  morph() {
    for (const row of this.rows) {
      if (!this.shown.has(row.id)) continue

      row
        .querySelector(".scaling-event-track")
        ?.getAnimations({ subtree: true })
        .forEach((animation) => animation.finish())
    }
    this.shown = this.rowIds
  }

  get rows() {
    return this.element.querySelectorAll(".scaling-event-row[id]")
  }

  get rowIds() {
    return new Set(Array.from(this.rows, (row) => row.id))
  }
}
